import { PATH } from 'types/router';
import APP from 'types/app';
import API from 'types/api';
import apiActions from 'actions/api';
import appActions from 'actions/app';
import { pathnameSelector, idSelector } from 'selectors/app';
import { isUserLoggedInSelector } from 'selectors/user';

export default (store) => (next) => (action) => {
  function getUserHistory(state) {
    const id = idSelector(state);
    store.dispatch(apiActions.getUserHistory(id));
  }

  if (action.type === APP.SET_PATHNAME && action.payload === PATH.EPISODES) {
    const state = store.getState();
    const isLoggedIn = isUserLoggedInSelector(state);
    const prevPathname = pathnameSelector(state);
    if (isLoggedIn && prevPathname === PATH.PLAYER) {
      if (state.player.property.started) {
        const position = state.player.property.position;
        const duration = state.player.property.duration;
        const movieId = state.player.stream.video_id;
        const objectId = state.app.id;
        const percent = Math.round(position / duration * 100);
        store.dispatch(appActions.saveMoviePosition(objectId, movieId, position, percent));
      }
    }
  } else if (
    action.type === API.GET_USER_SUCCESS ||
    action.type === API.POST_AUTH_SUCCESS ||
    action.type === API.POST_3RD_PARTY_AUTH_SUCCESS
  ) {
    getUserHistory(store.getState());
  }

  return next(action);
};
